export var slug = function slug(text) {
  return text.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
};
export default slug;